import { useEffect } from 'react';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { LegalProceedingsAnnexesProps } from './props';
import { LegalProceedingAnnexes } from '../../../../../../shared/types/legalProceedings/legalProceedings';
import { cleanObj } from '../../../../../../shared/utils/objects';

export const useLegalProceedingsAnnexes = ({
    data,
    onChangeData,
    onChangeFormik,
}: LegalProceedingsAnnexesProps) => {
    const onSubmit = (data: LegalProceedingAnnexes) => {
        if (onChangeData) onChangeData(cleanObj(data) || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('observations', data?.observations || '');
    }, [data]);

    return {
        formik,
    };
};
